---
title: Atelier Melbourne
year: 2023
typology: commercial
location: Melbourne, FL
summary: The BED studio itself. A 900-sq-ft workspace and material library in a 1962 mid-century commercial building — restored, lit, and stocked.
heroImage: /projects/atelier-melbourne/hero.svg
heroAlt: An interior designer's atelier with material library walls, a long blackened-steel worktable, and natural light from clerestory windows.
materials:
  - Blackened steel
  - Quarter-sawn ash
  - Linen-wrapped panels
  - Cork tile flooring
gallery:
  - src: /projects/atelier-melbourne/gallery/01.svg
    alt: Material library wall — linen-wrapped panels holding swatches of every BED material in current rotation.
    caption: The material library — twenty cubbies, four rows, every BED material in current rotation. The east wall is the studio's memory.
  - src: /projects/atelier-melbourne/gallery/02.svg
    alt: Long blackened-steel worktable covered with drawings and material samples.
    caption: The worktable — fifteen feet of blackened steel. Drawings, samples, current project files. Visitors lean over it.
  - src: /projects/atelier-melbourne/gallery/03.svg
    alt: Brass pendant lamp over the worktable, casting a wide soft pool of warm light.
    caption: The single pendant — a wide pool over the worktable. We made it locally; no fixture catalog has its proportions.
  - src: /projects/atelier-melbourne/gallery/04.svg
    alt: Loose material samples and design drawings spread across the worktable.
    caption: Working samples — wood, stone, fabric, brass — pinned to drawings. The studio's daily archeology.
  - src: /projects/atelier-melbourne/gallery/05.svg
    alt: Side view of the atelier with the material library to one side and the worktable to the other.
    caption: The whole room from the side — clerestory light from above, library to one side, worktable to the other.
placeholder: true
---

The studio's own space, and our most honest project — because we live in it.

A 1962 commercial unit, originally a dentist's office, then a mortgage broker, then empty for four years. We took the dropped ceiling out, exposed the clerestory windows, and discovered the building was better than anyone had let it be.

## Material library

The east wall is a full-height material library — linen-wrapped panels behind low-iron glass — for the trades, the clients, and the team. Specifications happen here. Conversations happen here.

## Worktable

The center of the room is a fifteen-foot-long blackened-steel worktable. Brian's drawings, samples, and current project files live on it. Visitors are welcome to lean over it.

*Studio operating since 2023. By appointment.*
